export default __webpack_public_path__ + "static/media/Hello.8062e010.png";